import { mapGetters } from 'vuex';
import modalLtiEmbedded from '@/components/gaia/modals/embedded-iframe';
import HtmlRenderContainer from '@/components/content-management/html-render-container';
import RenderLtiContainer from '../render';
import { hasSomeEqualWebAccessabilityOptionActive } from '@/helpers/equalweb';

export default {
  components: {
    modalLtiEmbedded,
    HtmlRenderContainer,
    RenderLtiContainer
  },
  props: {
    title: {
      type    : String,
      default : ''
    },
    content: {
      type    : Object,
      default : ''
    }
  },
  data() {
    return {
      ltiLaunch: {
        openDialog : false,
        title      : '',
        url        : ''
      }
    };
  },
  computed: {
    ...mapGetters({
      getterSelectedTopic: 'plataforma/content/getterSelectedTopic'
    }),
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    }
  },
  methods: {
    openLtiLaunch() {
      if (this.content.isForOpenInNewTab || hasSomeEqualWebAccessabilityOptionActive()) {
        window.open(`lti-launch/?type=lti&id=${this.content.topicId}`, '_blank');
      } else {
        this.ltiLaunch.title = this.getterSelectedTopic.title;
        this.ltiLaunch.url = `lti-launch/?type=lti&id=${this.content.topicId}`;
        this.ltiLaunch.openDialog = true;
      }
      this.emitProgress();
    },
    closeLtiModal() {
      this.ltiLaunch = {
        openDialog : false,
        title      : '',
        url        : ''
      };
    },
    emitProgress() {
      this.$nuxt.$emit('student-section', {
        type : 'markProgress',
        data : this.content.topicId
      });
    }
  }
};
